export default __webpack_public_path__ + "static/media/vet.e6c0036b.svg";